export default __webpack_public_path__ + "static/media/FiveStars.971b295c.svg";